import { Component } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-auth-navbar',
  templateUrl: './auth-navbar.component.html',
  styleUrls: ['../../app.component.css', '../navbar/navbar.component.css']
})

export class AuthNavbarComponent  {

  constructor(private router: Router) {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/auth-navbar/auth-navbar.component.ts